<!-- DayMenuView.vue -->
<script setup lang="ts">
import type { MessageSchema } from '@/i18n';
import { usePostitsStore } from '@/stores/postitsStore';
// import { useUserStore } from '@/stores/useUserStore';
import type { Postit } from '@/types/planning';
import PostitCard from '@/views/Employee/PostitCard.vue';
import { onMounted, ref, watch, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
// import { useRouter } from 'vue-router';
// const user = ref(useUserStore().user);
// const restaurantId = user.value?.restaurants[0]?.id || null;

// Define props for the component
const props = defineProps<{
  date: Date;
}>();
const postitsStore = ref(usePostitsStore());
const postitsForDay: Ref<Postit[]> = ref([]);
const { t, locale } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
// const router = useRouter();

async function fetchPostitsForDay() {
  const formattedDate = props.date.toISOString().split('T')[0];
  postitsForDay.value = postitsStore.value.getPostitsByDate(formattedDate);
}
// Define a list of dishes for the current day

const containerRef = ref<HTMLDivElement | null>(null);
const showLeftShadow = ref(false);
const showRightShadow = ref(false);

function handleScroll() {
  if (!containerRef.value) return;
  const scrollLeft = containerRef.value.scrollLeft;
  const maxScrollLeft = containerRef.value.scrollWidth - containerRef.value.clientWidth;

  showLeftShadow.value = scrollLeft > 0;
  showRightShadow.value = scrollLeft < maxScrollLeft;
}

onMounted(() => {
  fetchPostitsForDay();
  if (containerRef.value) {
    containerRef.value.addEventListener('scroll', handleScroll);
  }
});

// Add a new dish to the list
// function addPostit() {
//   const newPostit: Postit = {
//     id: -1, // Placeholder ID, will be replaced by actual ID on server response
//     tempId: Date.now(), // Temporary ID for local use
//     // title: '',
//     is_done: false,
//     planned_date: props.date.toISOString().split('T')[0],
//     restaurant_id: 'default_restaurant_id',
//   };

//   postitsStore.value.addPostit(newPostit, restaurantId, router);
// }

function isToday(date: Date): boolean {
  const today = new Date();
  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
}

watch(
  () => postitsStore.value.postits,
  () => {
    fetchPostitsForDay();
  },
  { deep: true },
);

watch(
  () => props.date,
  () => {
    fetchPostitsForDay();
  },
);
</script>

<template>
  <!-- <h3 class="font-semibold">{{ date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }) }}</h3> -->
  <!-- {{ postitsForDay }} -->
  <div class="my-4 flex w-full flex-col items-center">
    <!-- Left side for the day and number -->
    <div
      :class="[
        'text-center',
        'p-2',
        'rounded-md',
        'flex',
        'flex-col',
        'justify-center',
        'min-w-12',
        'mx-0',
        'mb-4',
        isToday(props.date) ? 'bg-accent text-white' : 'text-primary',
      ]"
    >
      <span class="text-xs">{{ t(`common.dayShort.${props.date.toLocaleDateString('en-US', { weekday: 'short' })}`) }}</span>
      <!-- <span class="text-lg font-bold">{{ props.date.getDate() }}</span> -->
      <span class="font-bold text-sm">
        {{ props.date.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' }) }}
      </span>
    </div>

    <!-- Outer container for scrollable content with shadows -->
    <div class="scroll-container relative w-full">
      <div ref="containerRef" class="hide-scrollbar p flex items-center justify-center overflow-x-auto" @scroll="handleScroll">
        <div class="ml-2 flex flex-row flex-wrap justify-center gap-4">
          <div v-for="postit in postitsForDay" :key="postit.id">
            <PostitCard :date="props.date" :postit="postit"></PostitCard>
            <!-- other menu details -->
          </div>
          <!-- <MenuView :date="props.date"></MenuView>
          <MenuView :date="props.date"></MenuView>
          <MenuView :date="props.date"></MenuView> -->
          <!-- Add more MenuView components here -->
          <!-- <div class="relative cursor-pointer " @click="addPostit">
            <div class="absolute inset-0 z-10 flex items-center justify-center">
              <button class="flex items-center justify-center w-10 p-1 text-white rounded-full bg-accent aspect-square">
                <i class="pi pi-plus" style="font-size: 1rem"></i>
              </button>
            </div>
            <div
              class="relative flex items-start flex-grow h-56 px-4 py-8 mx-2 my-4 shadow-lg opacity-25 w-44 bg-primary-200 rounded-xl">
              <div class="absolute px-4 py-2 overflow-hidden text-xs font-bold text-center text-black truncate -translate-x-1/2 rounded-md -top-4 left-1/2 bg-primary-600 whitespace-nowrap text-ellipsis max-w-36">
                <p class="w-24 h-4"></p>
              </div>
              <div class="flex flex-col justify-around gap-3 text-sm ">
              </div>
            </div>
          </div> -->
        </div>

        <!-- "Plus" button to add a new dish -->
      </div>

      <!-- Shadows for overflow on the left and right -->
      <!-- <div v-if="showLeftShadow" class="left-shadow"></div>
      <div v-if="showRightShadow" class="right-shadow"></div> -->
    </div>
  </div>
</template>

<style scoped>
/* Hide the scroll bar but still allow horizontal scrolling */
.hide-scrollbar {
  overflow-x: auto;
  scrollbar-width: none;
  /* Firefox */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

/* Outer container to hold the scrollable area and the shadows */
/* .scroll-container {
  position: relative;
  max-width: 100%;
  width: 100%;
} */

/* Inner shadow for overflow */
.left-shadow,
.right-shadow {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 6px;
  /*10*/
  pointer-events: none;
  /* z-index: 0; */
}

.left-shadow {
  left: 0;
  /* background: linear-gradient(to right, rgba(255, 255, 255, 1), transparent); */
  background: linear-gradient(to right, rgb(193 214 224), rgba(193, 214, 224, 0));
}

.right-shadow {
  right: 0;
  /* background: linear-gradient(to left, rgba(255, 255, 255, 1), transparent); */
  background: linear-gradient(to left, rgb(193 214 224), rgba(193, 214, 224, 0));
}
</style>
